"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxOption = void 0;
const react_1 = __importDefault(require("react"));
const styled_1 = require("./styled");
const main_1 = require("./main");
const CheckboxOption = (_a) => {
    var { children, value, checked, onChange, disabled, variant } = _a, props = __rest(_a, ["children", "value", "checked", "onChange", "disabled", "variant"]);
    function handleKeyDown(e) {
        onChange && e.key === "Enter" && onChange(!checked);
    }
    function handleClick(e) {
        e.stopPropagation();
        e.preventDefault();
        onChange && !disabled && onChange(!checked);
    }
    return (react_1.default.createElement(styled_1.StyledOption, Object.assign({}, props, { disabled: disabled, onClick: handleClick, onKeyDown: handleKeyDown, "data-testid": "checkboxlist-option" }),
        react_1.default.createElement(main_1.Checkbox, { checked: checked, disabled: disabled, variant: variant }),
        children));
};
exports.CheckboxOption = CheckboxOption;
//# sourceMappingURL=option.js.map